import React, { useEffect, useState } from "react";
import { Getdata } from "../../helpers/api.service";
import { useNavigate } from "react-router-dom";

const Streams = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  let [loading, setLoading] = useState(false);
  const fetchData = () => {
    setLoading(true);
    Getdata(
      process.env.REACT_APP_URL +
        `/front/education/stream/fetch/${process.env.REACT_APP_SUBDOMAIN}`
    )
      .then((res) => {
        console.log("News API response:", res);
        if (res?.data) {
          setData(res.data);
        }
        // setImages(res.data.map((item) => item.image));
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching news:", err);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-3 text-start">
        {data.length > 0 &&
          data.map((item, index) => (
            <div className="border-[#EAEAEA] bg-[#F9F5FF] border-[1px] rounded-lg p-[15px]  relative text-gray-800  ">
              <div>
                <h2 className="text-[15px] font-semibold mb-2">{item.grade}</h2>
                <div className="grid grid-cols-1 md:flex md:justify-between   ">
                  <div className="text-[12px] mb-4 text-[#7C7C7C] font-normal">
                    Stream : {item.name}
                  </div>
                  <div className="text-[12px] mb-4 text-[#7C7C7C] font-normal">
                    No.Of Students : {item.no_of_students}
                  </div>
                </div>
                <div className="flex  items-center  gap-2 mb-4">
                  <div className="">
                    <img
                      className="w-10 h-10 object-cover  rounded-full "
                      src={item.teacher_image}
                    />
                  </div>
                  <div className="text-[15px] flex items-center font-semibold">
                    {item.teacher}
                  </div>
                </div>

                <div className="mb-2">
                  <p className="text-sm leading-relaxed">
                    {item.description
                      ? item.description
                      : "No Details available for this Teacher."}
                  </p>
                </div>
              </div>
            </div>
          ))}
      </div>
      {data.length === 0 && (
        <div className="h-[50vh] flex items-center justify-center w-full">
          <h1 className="text-center text-gray-400">No Data Found</h1>
        </div>
      )}
    </>
  );
};

export default Streams;
